import { useRequest } from "ahooks";
import { useRef } from "react";
import request from "../../../network/request";
import useBasicFormData from "./useBasicFormData";

// 获取取送车权益
export default function useUserRightRequest() {
  const loadingRightsStateRef = useRef(false);
  const { basicFormData, setContactInfoData } = useBasicFormData();

  return useRequest(
    async ({ vin, reserveId, preComeDate }) => {
      loadingRightsStateRef.current = true;
      try {
        loadingRightsStateRef.current = true;
        const userRightDto: any = await request(
          "module/maintenance/vehicleFetchRight",
          {
            vin,
            reserveId: reserveId || "",
            preComeDate: preComeDate || "",
          },
          "POST"
        );
        setContactInfoData({
          loadedServiceRight: true,
          usePickupService:
            !!userRightDto?.haveRight && !userRightDto?.tooFar && basicFormData.contactInfoStepData.usePickupService,
          hasPickupServiceRight: !!userRightDto?.haveRight,
          pickupRightUrl: userRightDto?.rightUrl || "",
          pickupServiceTooFar: userRightDto?.tooFar || false,
        });
      } catch (error) {
        setContactInfoData({
          loadedServiceRight: true,
        });
        throw error;
      } finally {
        loadingRightsStateRef.current = false;
      }
    },
    {
      manual: true,
    }
  );
}
